import styles from './get-one-week-trial.module.scss';

export const GetOneWeekTrial = () => {
  return <div className={styles.container}>Get +1 week to your trial</div>;
};
